<p-sidebar
  #sidebarRef
  [visible]="isSidebarOpen()"
  [modal]="false"
  [showCloseIcon]="false"
  [closeOnEscape]="true"
>
  <ng-template pTemplate="headless">
    <div class="flex flex-column h-full">
      <div class="flex justify-content-end">
        <p-button
          styleClass="sidebar-text"
          type="button"
          (onClick)="closeCallback($event, true)"
          icon="pi pi-times sidebar-text"
          styleClass="h-2rem w-2rem"
        ></p-button>
      </div>
      <div class="logo-container">
        <img
          class="outamation-logo"
          src="assets/images/icon.svg"
          alt="Outamate"
        />
      </div>

      <div class="overflow-y-auto">
        <ul class="list-none p-0 px-2 m-0">
          <li>
            <ul
              class="list-none p-0 m-0 overflow-hidden"
              *ngFor="
                let menu of commonService.getActivatedMenuItems(
                  sidebarService.menuItems()
                )
              "
            >
              <li *ngIf="!menu.items">
                <a
                  *ngIf="menu.visible"
                  [routerLink]="menu.command ? null : [menu.routerLink]"
                  (click)="
                    menu.command ? menu.command() : closeCallback($event)
                  "
                  pRipple
                  class="flex align-items-center cursor-pointer p-2 border-round text-700 transition-duration-150 transition-colors p-ripple"
                >
                  <i
                    [ngClass]="['mr-3', 'fa-solid', 'sidebar-text', menu.icon]"
                  ></i>
                  <span class="font-medium sidebar-text">{{ menu.label }}</span>
                </a>
              </li>
              <li *ngIf="menu.items">
                <a
                  *ngIf="menu.visible"
                  pRipple
                  pStyleClass="@next"
                  enterClass="hidden"
                  enterActiveClass="slidedown"
                  leaveToClass="hidden"
                  leaveActiveClass="slideup"
                  class="flex align-items-center cursor-pointer p-2 border-round text-700 transition-duration-150 transition-colors p-ripple"
                >
                  <i
                    [ngClass]="['mr-3', 'fa-solid', 'sidebar-text', menu.icon]"
                  ></i>
                  <span class="font-medium sidebar-text">{{ menu.label }}</span>
                  <i class="pi pi-chevron-down ml-auto sidebar-text"></i>
                </a>
                <ul
                  class="text-sm list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out"
                >
                  <li *ngFor="let submenu of menu.items">
                    <a
                      *ngIf="submenu.visible"
                      [routerLink]="
                        submenu.command ? null : [submenu.routerLink]
                      "
                      (click)="
                        submenu.command
                          ? submenu.command()
                          : closeCallback($event)
                      "
                      pRipple
                      class="flex align-items-center cursor-pointer p-1 border-round text-700 transition-duration-150 transition-colors p-ripple"
                    >
                      <i class="pi pi-circle-on mr-2 sidebar-text text-5xs"></i>
                      <span class="font-medium sidebar-text">{{
                        submenu.label
                      }}</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="mt-auto mb-2">
        <hr class="mb-3 mx-3 border-top-1 border-none surface-border" />
        <span class="flex justify-content-around align-items-center">
          <span class="mr-4 color-white font-medium">Always Visible</span>
          <p-inputSwitch
            [ngModel]="isSidebarAlwaysOpen()"
            (onChange)="changeSideBarPreference($event)"
          ></p-inputSwitch>
        </span>
      </div>
    </div>
  </ng-template>
</p-sidebar>
